import React from "react";
import { RouteDashboard } from "app/pages/RouteDashboard";
import { MobileRoutesPage } from "app/mobile/pages/MobileRoutesPage";
import { useMobileLayout } from "app/hooks/useMobileLayout";

export function ResponsiveRoutesPage() {
  const isMobile = useMobileLayout();
  return isMobile ? <MobileRoutesPage /> : <RouteDashboard />;
}
